import {Routes} from '@angular/router';
import {AuthGuard} from '@core/guards/auth.guard';

export const routes: Routes = [
  {
    path: 'start',
    loadChildren: () =>
      import('./shells/start/routes/start.routes')
        .then(m => m.StartRoutes),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./shells/auth/routes/auth.routes')
        .then(m => m.AuthRoutes),
    data: {
      preload: true
    }
  },
  {
    path: 'client',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./shells/client/routes/client.routes')
        .then(m => m.ClientRoutes),
    data: {
      preload: true
    }
  },
  {
    path: 'admin',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./shells/admin/routes/admin.routes')
        .then(m => m.AdminRoutes),
    data: {
      preload: true
    }
  },
  {
    path: 'simulator',
    loadChildren: () =>
      import('./shells/simulator/routes/simulator.routes')
        .then(m => m.SimulatorRoutes),
    data: {
      preload: true
    }
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./shells/payment/routes/payment.routes')
        .then(m => m.PaymentRoutes),
    data: {
      preload: true
    }
  },
  {
    path: '**',
    redirectTo: 'start',
  },
];
